/**
 * VarietyDropdownSearchSearch
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearPageOnChange: boolean;
    updateQueryString: Function;
    varieties?: string | string[];
    options: {
        key: number,
        text: string,
        value: number
    }[];
    multiple?: boolean;
    fluid?: boolean;
}

export class VarietyDropdownSearchSearch extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { clearPageOnChange } = this.props;
        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            varieties: data.value || undefined,
            selectedEvent: undefined
        });
    };

    render() {
        const { varieties, options, multiple, fluid } = this.props;
        return (
            <Dropdown
                placeholder="All Varieties"
                search
                selection
                value={varieties || null}
                clearable
                selectOnBlur={false}
                options={options}
                onChange={this.handleChange}
                lazyLoad
                multiple={multiple}
                closeOnChange
                fluid={fluid}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    varieties: makeSelectQueryStringValue('varieties'),
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(VarietyDropdownSearchSearch);
